module.exports = __webpack_public_path__ + "media/images/february23/february23-template-md-ae3d2bfbf6cde01a5b026b0f4348f6a3.png";